module.exports = __webpack_public_path__ + "static/media/preview-placeholder-w480h270.b31996d2.svg";